import { AxiosPromise } from 'axios'
import camelize from 'camelize'
import { useGeckoAuth } from 'features/auth'
import { RolodexContext } from 'features/rolodex/RolodexProvider'
import { useContext } from 'react'
import useSWR from 'swr'
import { RolodexPermissionsUser, RolodexUserMetadata } from 'types'

export const useRolodexPermissionsUser = () => {
  const { authorizedAxios } = useGeckoAuth()
  const { apiURL } = useContext(RolodexContext)
  return {
    // not currently used, but keeping around since we inevitably will want it
    patchRolodexPermissionsUser: (
      user: RolodexPermissionsUser
    ): AxiosPromise<RolodexPermissionsUser> =>
      authorizedAxios.patch(
        `${apiURL}/api/v2/permissions/user/${user.id}`,
        user
      ),
    // utilized by the toggle in the top bar
    patchCurrentRolodexPermissionsUser: (
      user: RolodexPermissionsUser
    ): AxiosPromise<RolodexPermissionsUser> =>
      authorizedAxios.patch(`${apiURL}/api/v2/permissions/user`, user),
  }
}

export const useRolodexPermissionsAllUserMetadata = () => {
  const { isAuthenticated, authorizedAxios: axios } = useGeckoAuth()
  const { apiURL } = useContext(RolodexContext)

  const { data, isLoading } = useSWR<RolodexUserMetadata[], string>(
    isAuthenticated ? `${apiURL}/api/v2/permissions/user-metadata/all` : null,
    async (url: string) => {
      if (!url) {
        return Promise.resolve(null)
      }
      const response = await axios.get(url, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      return camelize(response.data)
    }
  )

  const geckoUsers = (data || []).filter((user) =>
    user.roles.find((r) => r.name === 'gecko:internal:member')
  )

  return {
    data: geckoUsers,
    isLoading,
  }
}
